import { Position } from '@ryusei/code';


/**
 * The origin position.
 *
 * @since 0.1.0
 */
export const ORIGIN: Position = [ 0, 0 ];

/**
 * The delay time for reselection after scroll ends.
 *
 * @since 0.1.0
 */
export const DELAY_FOR_RESELECTION = 5;
